import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import * as UserActions from "./../actions/user_actions";
import * as FacilitiesActions from "./../actions/facilities_actions";
// import * as PatientsActions from './../actions/admin/patients_actions';
import { bindActionCreators } from "redux";
import * as ValidataionMessages from "./../validationMessages";
// import * as AdminDashboardActions from './../actions/admin/dashboard_actions';
import * as DashboardActions from "./../actions/dashboard_actions";
import { ModalDialogCommon } from "./../components/modal_dialog_common";
import Modal from "react-modal";
let Loging = React.createClass({
  getInitialState() {
    return {
      errorMsg: null,
      confimationModalMessage: null,
      autoLogoutSessionKey: null,
      userId: null,
      otpModelMessage: null,
      otpModelCode: false,
      email: null,
      modelMgs: "",
      timer: {},
      mins: 3,
      secs: 60,
      otpError: "",
      isPasswodExpired: false,
    };
  },

  // if user already logged in to the system
  componentWillMount() {
    if (
      this.props.LogingDetails &&
      (this.props.LogingDetails.status === 202 ||
        this.props.LogingDetails.status === 406)
    ) {
      this.props.Dispatch(UserActions.user_log_out());
    }
    this.setState({ errorMsg: null });
    if (
      this.props.LogingDetails &&
      this.props.LogingDetails.data &&
      this.props.LogingDetails.data.sequrityAnswer &&
      this.props.LogingDetails.data.sequrityAnswer.length === 0
    ) {
      if (this.props.UserDetails.selectedUserRoleID) {
        this.props.router.push("/securityquestion");
      }
    }
    // SuperAdmin Redirection

    if (
      this.props.LogingDetails &&
      this.props.LogingDetails.data &&
      this.props.LogingDetails.status === 200 &&
      !this.props.LogingDetails.data.facilities[0].facility
    ) {
      if (this.props.LogingDetails.data.sequrityAnswer.length === 0) {
      } else {
        this.props.router.push("/dashboard");
        this.props.Dispatch(
          FacilitiesActions.getfacilitiesbySearch({
            searchChar: "",
            page: 1,
            size: 9,
          })
        );
        this.props.Dispatch(DashboardActions.notifications());
        var id = this.props.LogingDetails.data.id;
        this.props.Dispatch(FacilitiesActions.getAdminUserById(id + "/" + 0));
      }
    } else if (
      this.props.LogingDetails &&
      this.props.LogingDetails.status === 200 &&
      this.props.LogingDetails.data
    ) {
      this.props.router.push("/select-clinic");
    }
  },
  componentWillReceiveProps(nextProps) {
    if (nextProps.OTPResponse) {
      if (
        nextProps.OTPResponse.status === 200 &&
        nextProps.LogingDetails &&
        nextProps.LogingDetails.status !== 406
      ) {
        this.setState({ otpModelMessage: null, otpModelCode: false }, () => {
          this.loginHandler();
        });
      } else if (nextProps.OTPResponse.status !== 200) {
        this.setState({ otpError: nextProps.OTPResponse.message });
        if (nextProps.OTPResponse.status === 417) {
          this.setState({
            // otpError: "This OTP EXpired a new otp is sent to you email.",
            otpError: "OTP expired, try 'Resend OTP' option.",
          });
          // this.loginHandler();
        }
      }
    }

    // if Auto session logout response
    if (nextProps.SessionLogoutResponse) {
      if (nextProps.SessionLogoutResponse.status === 200) {
        this.props.Dispatch(UserActions.user_log_out());
        localStorage.clear();
        this.props.router.push("/");
      } else {
        // need to show error msg from server response
      }
    }

    // Error handling if wrong uname & password
    if (
      (nextProps.LogingDetails &&
        (nextProps.LogingDetails.data === null ||
          nextProps.LogingDetails.data === undefined)) ||
      (nextProps.LogingDetails && nextProps.LogingDetails.status !== 200)
    ) {
      if (nextProps.LogingDetails && nextProps.LogingDetails.status === 409) {
        this.setState({
          confimationModalMessage: nextProps.LogingDetails.message,
          autoLogoutSessionKey: nextProps.LogingDetails.data.uniqueKey,
          userId: nextProps.LogingDetails.data.id,
        });
        return;
      } else if (
        nextProps.LogingDetails &&
        nextProps.LogingDetails.status === 202 &&
        !nextProps.OTPResponse
      ) {
        nextProps.LogingDetails.status &&
          this.setState({
            otpModelMessage: !this.state.otpModelMessage
              ? "A otp is sent to the registered email address"
              : this.state.otpModelMessage,
          });
        return;
      } else if (
        nextProps.LogingDetails &&
        nextProps.LogingDetails.status === 412
      ) {
        this.setState({ isPasswodExpired: true });
      } else if (
        nextProps.LogingDetails &&
        nextProps.LogingDetails.status !== 200
      ) {
        this.setState({ errorMsg: nextProps.LogingDetails.message });
      }
      if (!nextProps.OTPResponse) {
        this.setState({ errorMsg: nextProps.LogingDetails.message });
        return;
      }
    }

    // On API Success
    this.setState({ errorMsg: null });

    // SuperAdmin Redirection
    if (
      nextProps.LogingDetails &&
      nextProps.LogingDetails.data &&
      nextProps.LogingDetails.status === 200
    ) {
      if (
        nextProps.LogingDetails.data &&
        !nextProps.LogingDetails.data.facilities[0].facility
      ) {
        this.props.Dispatch(
          UserActions.selectedUserRoleID(
            nextProps.LogingDetails.data.facilities[0].role.id
          )
        );

        if (nextProps.LogingDetails.data.sequrityAnswer.length === 0) {
          this.props.router.push("/securityquestion");
        } else {
          this.props.router.push("/dashboard");
          this.props.Dispatch(
            FacilitiesActions.getfacilitiesbySearch({
              searchChar: "",
              page: 1,
              size: 9,
            })
          );
          this.props.Dispatch(DashboardActions.notifications());
          var id = nextProps.LogingDetails.data.id;
          this.props.Dispatch(FacilitiesActions.getAdminUserById(id + "/" + 0));
        }
        return false;
      } else if (nextProps.LogingDetails.data.passwordChange) {
        //this.props.router.push('/newpassword?passwordChanged');
        this.props.router.push(
          "/newpassword?id=" +
          nextProps.LogingDetails.data.id +
          "&?k=" +
          nextProps.LogingDetails.data.uniqueKey +
          "&?passwordChanged=" +
          true
        );
        return false;
      } else if (nextProps.LogingDetails.data.sequrityAnswer.length === 0) {
        this.props.router.push("/securityquestion");
      } else {
        this.props.router.push("/select-clinic");
      }
    }
  },

  loginHandler() {
    if (
      this.refs.username.value.trim().length &&
      this.refs.password.value.trim().length
    ) {
      var data = {
        userName: this.refs.username.value,
        password: this.refs.password.value,
        identifier: 0,
      };

      var cookie = document.cookie
        ? document.cookie.split(";").filter(function (data) {
          var keyName = data.split("=")[0];
          return keyName == "users" ? data.split("=")[1] : [];
        })
        : [];

      let users = [];
      if (cookie[0]) {
        if (cookie[0].includes('users')) {
          users = JSON.parse(cookie[0].split("=")[1]);
        }
      }
      let that = this;
      let userData = users.filter(function (user) {
        return user.name === that.refs.username.value;
      });

      if (userData[0]) {
        data["deviceKey"] = userData[0].deviceKey;
      }

      if (this.props.LogingDetails && this.props.LogingDetails.status === 202) {
        data["deviceKey"] = this.props.LogingDetails.data.deviceKey;
        if (cookie[0]) {
          document.cookie = "users=" + JSON.stringify([]);
        }
        var userExpiryDate = new Date();
        let expDate = new Date(
          userExpiryDate.getTime() + 1000 * 60 * 60 * 24 * 7
        );
        var currentUser = [
          {
            name: this.refs.username.value,
            deviceKey: this.props.LogingDetails.data.deviceKey,
          },
        ];
        // users.push({
        //   name: this.refs.username.value,
        //   deviceKey: this.props.LogingDetails.data.deviceKey,
        // });
        document.cookie = "users=" + JSON.stringify(currentUser);
        document.cookie = "expires = " + expDate.toUTCString() + ";";
      }
      this.props.Dispatch(UserActions.userLlogin(data));
    } else {
      this.setState({
        errorMsg: ValidataionMessages.userNamePassword,
      });
    }
  },
  resendOTP() {
    var data = {
      userName: this.refs.username.value,
      password: this.refs.password.value,
      identifier: 0,
    };
    this.props.Dispatch(UserActions.userLlogin(data));
    this.setState({ otpModelMessage: "A New OTP sent to your email " });
  },
  clear() {
    this.setState({
      errorMsg: null,
    });
  },
  forgotUserName() {
    this.props.router.push("/forgotUname");
  },
  forgotpassword() {
    this.props.router.push("/forgotpassword");
  },
  handleKeyPress(e) {
    if (e.key === "Enter") {
      this.loginHandler();
    }
  },
  onOtpConfirmed() {
    // this.setState({ modelMgs: 'We just sent you an XXXX digit code to email ' + this.props.LogingDetails.data.email + ' Please enter the code below.' });
    this.setState({
      modelMgs:
        "We just sent you an XXXX digit code to your registered Email ID. Please enter the code below.",
    });
    this.setState({ otpModelCode: true, otpModelMessage: "" });
  },
  onConfirmed() {
    this.props.Dispatch(
      UserActions.userAutoLogout({
        id: this.state.userId,
        uniqueKey: this.state.autoLogoutSessionKey,
      })
    );
    this.closebox();
  },

  closebox() {
    this.setState({
      otpModelCode: false,
      otpModelMessage: "",
      modelMgs: "",
      errorMsg: null,
      confimationModalMessage: null,
      otpError: "",
    });
    this.props.Dispatch(UserActions.user_log_out());
  },

  verifyOTP() {
    this.props.Dispatch(
      UserActions.verifyOTP({
        otp: this.refs.otpcode.value,
        id: this.props.LogingDetails.data.userId,
        deviceKey: this.props.LogingDetails.data.deviceKey,
      })
    );
  },
  togglePassword() {
    var pwd = document.getElementById("password");
    pwd.type === "password" ? (pwd.type = "text") : (pwd.type = "password");
  },

  render() {
    return (
      <div className="vertalign-container">
        <div className="vertalign-child">
          <div className="admin-login login-box">
            <h1 className="top-logo">MOBI</h1>
            <div className="input-group">
              <input
                type="text"
                className="inputText"
                required
                ref="username"
              />
              <span className="floating-label">Username</span>
            </div>
            <div className="input-group">
              <input
                type="password"
                className="inputText"
                required
                ref="password"
                id="password"
                onKeyPress={this.handleKeyPress}
              />
              <span className="floating-label">Password</span>
              <img
                src={require("./../images/eye-open.png")}
                className="eye-icon"
                onClick={() => {
                  this.togglePassword();
                }}
              />
            </div>
            <div className="error-message">
              <span className={this.state.errorMsg === null ? "hidden" : ""}>
                {this.state.errorMsg}
              </span>
            </div>
            <button
              className="gray-button admin-login-button"
              onClick={this.loginHandler}
            >
              login
            </button>

            <p className="login-text">
              <a
                className="forgot-name pull-left"
                onClick={this.forgotUserName}
              >
                forgot username?
              </a>
              <a
                className="forgot-name pull-right"
                onClick={this.forgotpassword}
              >
                forgot password?
              </a>
            </p>
          </div>
        </div>

        {this.state.otpModelCode && (
          <Modal
            isOpen={this.state.otpModelCode}
            className="delete-prompt modalPopup logout"
            contentLabel="modalPopup"
          >
            <div className="popup-content profile OTP_content text-center">
              <p className="verify_text">Verify Yourself</p>
              <p className="main_header">
                {/* We just sent you an XXXX digit code to {this.props.LogingDetails.data.email}.
                            Please enter the code below. */}
                We just sent you an XXXX digit code to your registered Email ID.
                Please enter the code below.
              </p>
              <div>
                <div className="input-group">
                  <input
                    type="text"
                    ref="otpcode"
                    className="inputText opt_Textbox"
                    onKeyPress={this.handleKeyPress}
                    required
                    maxLength={4}
                  />
                  <span className="floating-label Otp_label">OTP</span>
                  <div className="OTP_error">{this.state.otpError}</div>
                </div>
                <div className="resend-otp">
                  <a className="resent" onClick={this.resendOTP.bind(this)}>
                    Resend otp?
                  </a>
                </div>

                <input
                  type="button"
                  value="SUBMIT"
                  className="button button-primary btn-submit gray-button"
                  ref="deleteBtn"
                  onClick={() => {
                    this.props.Dispatch(
                      UserActions.verifyOTP({
                        otp: this.refs.otpcode.value,
                        id: this.props.LogingDetails.data.userId,
                        deviceKey: this.props.LogingDetails.data.deviceKey,
                      })
                    );
                  }}
                />
                <input
                  type="button"
                  value="CANCEL"
                  className="button button-primary btn-submit white-button"
                  ref="deleteCancelBtn"
                  onClick={this.closebox}
                />
              </div>
            </div>
          </Modal>
        )}

        {this.state.isPasswodExpired && (
          <Modal
            isOpen={this.state.isPasswodExpired}
            className="delete-prompt modalPopup logout"
            contentLabel="modalPopup"
          >
            <div className="popup-content profile OTP_content text-center">
              <p className="verify_text">Reset Password</p>
              <p className="main_header">
                Password expired. Please reset your password.
              </p>
              <div>
                <input
                  type="button"
                  value="OK"
                  className="button button-primary btn-submit gray-button"
                  ref="deleteBtn"
                  onClick={() => {
                    this.props.router.push(
                      "/newpassword?id=" +
                      this.props.LogingDetails.data.id +
                      "&?k=" +
                      this.props.LogingDetails.data.uniqueKey +
                      "&?passwordChanged=" +
                      true
                    );
                  }}
                />
              </div>
            </div>
          </Modal>
        )}

        {this.state.otpModelMessage && (
          <ModalDialogCommon
            message={this.state.otpModelMessage}
            cancel="true"
            action2={this.closebox}
            action={this.onOtpConfirmed}
          ></ModalDialogCommon>
        )}
        {this.state.confimationModalMessage && (
          <ModalDialogCommon
            message={this.state.confimationModalMessage}
            cancel="true"
            action2={this.closebox}
            action={this.onConfirmed}
          />
        )}
      </div>
    );
  },
});

let mapStateToProps = (state) => {
  return {
    UserDetails: state.User,
    LogingDetails: state.User.loginData,
    Notifications: state.Dashboard.Notifications,
    SessionLogoutResponse: state.User.sessionLogoutResponse,
    OTPResponse: state.User.OTPResponse,
  };
};

let mapDispatchToProps = (dispatch) => ({
  UserActions: bindActionCreators(UserActions, dispatch),
  Dispatch: dispatch,
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loging));



/** WEBPACK FOOTER **
 ** ./src/screens/home.jsx
 **/